// Story 8.3 (ADO-2012), Task 11.2: the designer's lifetime rule for Conflict Messages: a
// message stays until the Shopper taps its action, changes that line again, or leaves the
// page (the Order sent banner, card 10, too). The first two are the store's (a new edit of the line drops its conflict); this is
// the third. A change of path is leaving the page; a change of query (a filter, a page of
// results) is the same page. Mounted ONCE at the composition root (main.tsx), inside the
// router, as HhtWaitingCountRefresher is. It renders nothing.

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useBasketStore } from './useBasketStore';

export function ConflictsClearedOnLeave() {
  const { pathname } = useLocation();
  const shownPath = useRef(pathname);

  useEffect(() => {
    if (shownPath.current === pathname) return;
    shownPath.current = pathname;
    useBasketStore.getState().dismissConflicts();
    // Story 8.3 (ADO-2012), Task 13.4: the Order sent banner (card 10) lasts the same way.
    useBasketStore.getState().dismissOrderSent();
  }, [pathname]);

  return null;
}
